<script setup lang="ts">
const props = defineProps({
	color: {
		type: String,
		default: ICON_COLOR.DEFAULT,
	},
	width: {
		type: String,
		default: '20',
	},
	height: {
		type: String,
		default: '20',
	},
});
const color = computed(() => props.color);
const { color: iconColor } = useIconColor(color);
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.7622 14.1667H16.7404M10.7622 14.1667L9.16797 17.5M10.7622 14.1667L13.1499 9.17419C13.3423 8.77189 13.4385 8.57075 13.5701 8.50718C13.6846 8.4519 13.818 8.4519 13.9325 8.50718C14.0641 8.57075 14.1603 8.77189 14.3527 9.17419L16.7404 14.1667M16.7404 14.1667L18.3346 17.5M1.66797 4.16667H6.66797M6.66797 4.16667H9.58464M6.66797 4.16667V2.5M9.58464 4.16667H11.668M9.58464 4.16667C9.17119 6.63107 8.21179 8.86349 6.80593 10.737M8.33464 11.6667C7.8242 11.4373 7.30351 11.1184 6.80593 10.737M6.80593 10.737C5.67882 9.87314 4.67027 8.68886 4.16797 7.5M6.80593 10.737C5.46869 12.5191 3.7275 13.9765 1.66797 15"
      :stroke="iconColor"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
